import { render, staticRenderFns } from "./AttachmentBlock.vue?vue&type=template&id=835c6baa&scoped=true&"
import script from "./AttachmentBlock.vue?vue&type=script&lang=js&"
export * from "./AttachmentBlock.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentBlock.vue?vue&type=style&index=0&id=835c6baa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835c6baa",
  null
  
)

export default component.exports